import { useMemo, useContext } from 'react';
import CropGridValue from './CropGridValue';
import { CropAdjustmentContext } from './Contexts';
import { ColumnResizeContext } from './Contexts';
import G from './Getters';
import { useStore } from 'react-redux';

export default function LiveAdjustingCropGridValue(props){

 
  const store = useStore();
  const cropResizeInfo = useContext(CropAdjustmentContext);




  


  let laneDivider = useMemo(() => {
    let { liveSide="left" } = props;
    if( liveSide === "left" || liveSide === "right" ){
      return <CellWidthMarkOverlay cell={props.cell}/>
    }else{
      return null;
    }
  },[props])

  if( !cropResizeInfo ){
    return null;
  }

  let inlineCrop = {
    ...props.inlineCrop,
    ...(cropResizeInfo?.tempInlineCrop||{})
  }

  let atnId = cropResizeInfo?.value?.annotationId;

  let newInlineCrop =  G.getCropFromAnnotation(store.getState(),atnId,cropResizeInfo.atn);



  return (
    <>
      <CropGridValue {...{
        ...props,
        inlineCrop:newInlineCrop
      }}/>
      {laneDivider}
    </>
  )


}

function CellWidthMarkOverlay({cell}){
  const { currentWidths } = useContext(ColumnResizeContext); 


  let targetWidths =currentWidths.slice(cell.x,cell.x+cell.w);
  let targetLaneCount = targetWidths.length;

  let lineWidth = 3;



  let divider = Array(targetLaneCount).fill(null).map((_,ii) => (
    <line {...{
      x1:(ii*(100/targetLaneCount)+'%'),
        y1:0,
        y2:'100%',
        x2:(ii* 100/targetLaneCount)+'%',
        stroke:"white",
        strokeWidth:3
    }}/> 
  ));

  return (
    <svg class="absolute-cover outline">
      {divider}
    </svg>
  )

  /*


      width:`calc(${100/targetLaneCount}% + ${Math.floor(lineWidth/2)}px)`,
      borderLeft:(ii>0 && `${lineWidth}px solid rgba(0,0,0,1)`),
      //borderLeft:'1px solid rgba(0,0,0,1)',
      
    }}></div>
  ))

  return (
    <div class="sg-row" style={{position:'absolute',
      top:0,left:0,width:'100%',height:'100%',
      pointerEvents:'none', zIndex:50
      }}>
      {divider}
    </div>
  )

  let divider = Array(targetLaneCount).fill(null).map((_,ii) => (
    <div style={{
      width:`calc(${100/targetLaneCount}% + ${Math.floor(lineWidth/2)}px)`,
      borderLeft:(ii>0 && `${lineWidth}px solid rgba(0,0,0,1)`),
      //borderLeft:'1px solid rgba(0,0,0,1)',
      
    }}></div>
  ))

  return (
    <div class="sg-row" style={{position:'absolute',
      top:0,left:0,width:'100%',height:'100%',
      pointerEvents:'none', zIndex:50
      }}>
      {divider}
    </div>
  )
  */


}
